
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "ErrorMessage",
  props: {
    messages: { type: Object as PropType<string[]> },
  },
  setup() {},
});
